import { createIconComponent } from '../../factory/create-icon-component';
export const ChatIcon = createIconComponent(
  'ChatIcon',
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M12 1.25C17.9371 1.25 22.75 6.06294 22.75 12C22.75 17.9371 17.9371 22.75 12 22.75C10.786 22.75 9.72205 22.5769 8.72363 22.2197C7.83033 21.9002 7.46398 21.7701 7.35352 21.7441C6.8215 21.6191 6.46588 21.7249 6.04102 21.9268C5.63444 22.12 4.98496 22.5233 4.19336 22.6553C3.0689 22.8426 2.06787 21.9223 2.16113 20.7861C2.19589 20.3629 2.35523 19.9843 2.48145 19.7051C2.62585 19.3856 2.72563 19.194 2.78418 18.9902C3.01942 18.1711 2.73361 17.5756 2.24121 16.5127C1.60516 15.1397 1.25 13.6102 1.25 12C1.25 6.06294 6.06294 1.25 12 1.25ZM8 11C7.44772 11 7 11.4477 7 12C7 12.5523 7.44772 13 8 13C8.55228 13 9 12.5523 9 12C9 11.4477 8.55228 11 8 11ZM12 11C11.4477 11 11 11.4477 11 12C11 12.5523 11.4477 13 12 13C12.5523 13 13 12.5523 13 12C13 11.4477 12.5523 11 12 11ZM16 11C15.4477 11 15 11.4477 15 12C15 12.5523 15.4477 13 16 13C16.5523 13 17 12.5523 17 12C17 11.4477 16.5523 11 16 11Z"
      fill="currentColor"
    />
  </svg>,
);
